import { FC } from 'react'

import s from './s.module.scss'

const NotClaimDescription: FC = () => {
  return (
    <div className={s.descriptionWrapper}>
      <span className={s.description}>
        Sorry, this address isn&apos;t eligible for a <br /> reward. Why don&apos;t you try another wallet?
      </span>
    </div>
  )
}

export default NotClaimDescription
